import { TaxiVoiceProvider } from "@taunggyi-plus/taxi-feature";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { CustomerInformationDialog, MerchantMore } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import { FinanceOverview, PartnerPromotionRequests } from "@taunggyi-plus/finance-feature";
import { MerchantConsole } from "@taunggyi-plus/merchant-feature";
import { NotificationCenter } from "@taunggyi-plus/notifications";

const authConfig = {
  appId: "merchant",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

function MerchantDashboard({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-dashboard role-dashboard--merchant">
      <p>
        Partner accounts and business access are created by an administrator. Contact your
        administrator for access.
      </p>
      <MerchantConsole locale={locale} view="dashboard" />
    </div>
  );
}

function MerchantFoods({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-workspace role-workspace--merchant-foods">
      <MerchantConsole locale={locale} view="foods" />
      <PartnerPromotionRequests providerKind="merchant" />
    </div>
  );
}

function MerchantOrders({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-workspace role-workspace--merchant-orders">
      <MerchantConsole locale={locale} view="orders" />
    </div>
  );
}

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <TaxiVoiceProvider>
        <PlatformApp
          config={getAppConfig("merchant")}
          informationContent={(locale, id, onClose) => (
            <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
          )}
          navigationMode="owner"
          dashboardContent={(locale) => <MerchantDashboard locale={locale} />}
          myServicesLabel="Foods"
          myServicesPath="/foods"
          myServicesContent={(locale) => <MerchantFoods locale={locale} />}
          ordersContent={(locale) => <MerchantOrders locale={locale} />}
          financeContent={<FinanceOverview role="merchant" />}
          moreContent={(locale, onLocaleChange, onOpenPreferences) => (
            <MerchantMore
              locale={locale}
              onLocaleChange={onLocaleChange}
              onOpenPreferences={onOpenPreferences}
            />
          )}
          notificationContent={(locale) => (
            <NotificationCenter
              locale={locale}
              appId="merchant"
              embedded
              webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
            />
          )}
        />
      </TaxiVoiceProvider>
    </AuthProvider>
  </StrictMode>,
);
